import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  Button,
  Box,
  Typography,
  Switch,
} from "@mui/material";
import { useState } from "react";

const DURATION_OPTIONS = [60];

const normalize = (v) => v.toLowerCase().replace(/\s+/g, "_");

export default function BookingModal({ booking, onClose, onSave }) {
  const [label, setLabel] = useState(booking.label || "");
  const [hours, setHours] = useState(booking.meta.workingHours);
  const [durations, setDurations] = useState(booking.meta.durations);

  const valid = label.trim() && durations.length >= 1;

  const toggleDuration = (d) => {
    if (durations.includes(d)) {
      if (durations.length === 1) return;
      setDurations((p) => p.filter((x) => x !== d));
    } else {
      setDurations((p) => [...p, d]);
    }
  };

  const submit = () => {
    if (!valid) return;

    onSave({
      ...booking,
      label,
      meta: {
        ...booking.meta,
        workingHours: hours,
        durations,
      },
    });
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle fontWeight={800}>
        {booking.label ? "Edit Booking" : "Add Booking"}
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3} mt={1}>
          <TextField
            label="Booking Name"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            fullWidth
          />

          <Stack direction="row" spacing={2}>
            <TextField
              label="Start Hour"
              type="number"
              value={hours.start}
              onChange={(e) =>
                setHours({ ...hours, start: Number(e.target.value) })
              }
              fullWidth
            />
            <TextField
              label="End Hour"
              type="number"
              value={hours.end}
              onChange={(e) =>
                setHours({ ...hours, end: Number(e.target.value) })
              }
              fullWidth
            />
          </Stack>

          <Box>
            <Typography fontSize={14} fontWeight={700} mb={1}>
              Allowed Durations
            </Typography>

            <Stack spacing={1.5}>
              {DURATION_OPTIONS.map((d) => {
                const enabled = durations.includes(d);
                const locked = enabled && durations.length === 1;

                return (
                  <Box
                    key={d}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: "#F9FAFB",
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    <Typography fontWeight={600}>{d} minutes</Typography>

                    <Switch
                      checked={enabled}
                      disabled={locked}
                      onChange={() => toggleDuration(d)}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#2563EB",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#2563EB",
                          },
                      }}
                    />
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!valid} onClick={submit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
